import { defineAction } from '~/prix'
import { z } from 'zod'
import collectedAnimalFetchAction from './collectedAnimalFetch.action.json' with { type: 'json' }
import { collectedAnimalObject } from '../collectedAnimalObject'

const collectedAnimalFetchDefinition = defineAction({
  ...collectedAnimalFetchAction,

  input: z.object({ id: collectedAnimalObject.shape.id }),
  output: collectedAnimalObject,
})

export default collectedAnimalFetchDefinition
